import { w } from '@/lib/api'
import type { ResUserQuery } from '@/lib/queries/business/v2/user/types'

export const signUpMutation = {
  mutationFn: (data: { email: string; password: string }): Promise<ResUserQuery & { token: string }> =>
    w.post({ email: data.email, password: data.password }, '/business/v1/auth/signup').json(),
}
